import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getCategorias } from "../api";
import { motion } from "framer-motion";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";

const Categorias = () => {
  const [busqueda, setBusqueda] = useState("");
  const [filtradas, setFiltradas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();
  const navigate = useNavigate();

  const lastCategoriaRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    const filtradas = categorias.filter(cat =>
      cat.nombre.toLowerCase().includes(busqueda.toLowerCase())
    );
    setFiltradas(filtradas);
  }, [busqueda, categorias]);  

  const cargarCategorias = async () => {
    setLoading(true);
    try {
      const res = await getCategorias(page);
      if (res.success && res.categorias.length > 0) {
        setCategorias((prev) => {
          const todos = [...prev, ...res.categorias];
          const unicos = Array.from(new Map(todos.map(cat => [cat.id, cat])).values());
          return unicos;
        });
        if (res.categorias.length < 30) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (error) {
    }
    setLoading(false);
  };

  useEffect(() => {
    if (busqueda !== "" && hasMore && !loading) {
      setPage((prev) => prev + 1);
    }
  }, [busqueda, categorias]);

  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
    cargarCategorias();
  }, [page]);

  return (
    <motion.div
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: "100%", opacity: 0 }}
      transition={{ duration: 0.7, ease: "easeInOut" }}
    >
      <div className="app-container">
        <div className="connections-container">
          <div className="back-container">
            <button className="back-btn" onClick={() => navigate("/")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="48"
                  d="M244 400L100 256l144-144M120 256h292"
                />
              </svg>
            </button>
          </div>
          <h2 className="connections-title">Todas las categorías</h2>
        </div>
        <div className="feature-list">
        <div className="input-con-lupa" style={{ marginBottom: 10, paddingLeft:18, paddingRight:18 }}>
          <svg class="icono-lupa" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
            <path fill="currentColor" d="m19.485 20.154l-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503T5.47 5.436t4.064-1.667t4.068 1.664T15.268 9.5q0 1.042-.369 2.017t-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361t-1.37-3.36t-3.36-1.37t-3.361 1.37t-1.37 3.36t1.37 3.36t3.36 1.37" stroke-width="0.7" stroke="currentColor" />
          </svg>
          <input
            type="text"
            className="input-busqueda-inferior"
            placeholder="Búsqueda rápida..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
          {filtradas.length > 0 ? (
            filtradas.map((cat, i) => (
              <div
                key={cat.id}
                ref={i === filtradas.length - 1 ? lastCategoriaRef : null}
                className="feature-item"
                onClick={() => navigate(`/comercios/${cat.id}`, { state: { from: "all" } })}
              >
                <div className="icon" style={{ backgroundColor: "#f5f5f5" }}>
                  <img
                    src={cat.icono || "/assets/images/default.png"}
                    alt={cat.nombre}
                    width="22"
                    height="22"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/images/default.png";
                    }}
                  />
                </div>
                <div className="feature-text">
                  <h3>{cat.nombre}</h3>
                  <p>{cat.cantidad_de_comercios} comercios disponibles</p>
                </div>
              </div>
            ))
          ) : !loading ? (
            <p style={{ textAlign: "center", padding: "1rem" }}>No se encontraron resultados</p>
          ) : null}
        </div>

        {loading && (
          <div style={{ textAlign: "center", marginTop: 40, marginBottom:60 }}>
            <div className="custom-spinner"></div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default Categorias;
